import React from 'react';

import PropTypes from 'prop-types';
export const States = (props) => {
    const { states } = props;

    let title;

    if (!states || states.length === 0) {
        title = 'No States Selected';
    } else if (states.length === 51) {
        title = 'All States';
    } else {
        title = states.map((s) => s.abbreviation).join(', ');
    }

    return (
        <span>{ title }</span>
    );
};

States.propTypes = {
    states: PropTypes.arrayOf(PropTypes.shape({
        abbreviation: PropTypes.string.isRequired,
    })),
};
